export const DEFAULT_CHAIN_ID = process.env.REACT_APP_DEFAULT_CHAIN_ID
  ? Number(process.env.REACT_APP_DEFAULT_CHAIN_ID)
  : 4488

/**
 * List of all the networks supported by the Hydra Chain DEX Interface
 */
export enum SupportedChainId {
  HYDRA = 4488,
  TESTNET = 8844,
  DEVNET = 88441,
}

export const CHAIN_IDS_TO_NAMES = {
  [SupportedChainId.HYDRA]: 'hydrachain',
  [SupportedChainId.TESTNET]: 'hydrachain_testnet',
  [SupportedChainId.DEVNET]: 'hydrachain_devnet',
}

/**
 * Array of all the supported chain IDs
 */
export const ALL_SUPPORTED_CHAIN_IDS: SupportedChainId[] = Object.values(SupportedChainId).filter(
  (id) => typeof id === 'number'
) as SupportedChainId[]

export function isSupportedChain(chainId: number | null | undefined): chainId is SupportedChainId {
  return !!chainId && !!SupportedChainId[chainId]
}

export const SUPPORTED_GAS_ESTIMATE_CHAIN_IDS = [
  SupportedChainId.HYDRA,
  SupportedChainId.TESTNET,
  SupportedChainId.DEVNET,
]

/**
 * Unsupported networks for V2 pool behavior.
 */
export const UNSUPPORTED_V2POOL_CHAIN_IDS = []

export const TESTNET_CHAIN_IDS = [SupportedChainId.TESTNET, SupportedChainId.DEVNET] as const

export type SupportedTestnetChainId = typeof TESTNET_CHAIN_IDS[number]

/**
 * All the chain IDs that are running the Ethereum protocol.
 */
export const L1_CHAIN_IDS = [SupportedChainId.HYDRA] as const

export type SupportedL1ChainId = typeof L1_CHAIN_IDS[number]
